import { useUserStore } from 'stores';
import ChatGreetingView from './ChatGreeting.View';
import { ChatGreetingProps } from './types';

const ChatGreeting = (props: ChatGreetingProps) => {
  const { integrations } = props;
  const { user } = useUserStore();

  const isConnected = integrations.some((integration) => integration.isConnected);

  return (
    <ChatGreetingView
      isConnected={isConnected}
      username={user?.firstName || 'User'}
      integrations={integrations}
    />
  );
};

export default ChatGreeting;
